import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, unref as _unref, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, withKeys as _withKeys, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { id: "create-tenant" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("figure", null, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M9.57 5.93018L3.5 12.0002L9.57 18.0702M20.5 12.0002H3.67",
      "stroke-width": "1.5",
      "stroke-miterlimit": "10",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, "Voltar", -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = { class: "photo" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h1", null, "Logo do tenant", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", {
  class: "tooltip",
  for: "tenant-logo"
}, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M23 19C23 19.5304 22.7893 20.0391 22.4142 20.4142C22.0391 20.7893 21.5304 21 21 21H3C2.46957 21 1.96086 20.7893 1.58579 20.4142C1.21071 20.0391 1 19.5304 1 19V8C1 7.46957 1.21071 6.96086 1.58579 6.58579C1.96086 6.21071 2.46957 6 3 6H7L9 3H15L17 6H21C21.5304 6 22.0391 6.21071 22.4142 6.58579C22.7893 6.96086 23 7.46957 23 8V19Z",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M12 17C14.2091 17 16 15.2091 16 13C16 10.7909 14.2091 9 12 9C9.79086 9 8 10.7909 8 13C8 15.2091 9.79086 17 12 17Z",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", null, "A logo é exibida no menu do tenant para os usuários daquela conta.", -1)
const _hoisted_10 = { class: "double" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("h1", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Nome"),
  /*#__PURE__*/_createTextVNode(" (obrigatório)")
], -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("h1", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Sigla")
], -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("h1", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Setor"),
  /*#__PURE__*/_createTextVNode(" (obrigatório)")
], -1)
const _hoisted_14 = ["onMousedown"]
const _hoisted_15 = { class: "spacing" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("h1", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Módulos")
], -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("h2", null, "Controle quais funcionalidades pagas este tenant tem acesso.", -1)
const _hoisted_18 = { class: "modules" }
const _hoisted_19 = ["checked", "onChange"]
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_21 = { class: "spacing" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("h1", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Perfis de acesso"),
  /*#__PURE__*/_createTextVNode(" (obrigatório ao menos 1)")
], -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("h2", null, "Perfis padrão que serão criados junto com o tenant. Desmarque os que não forem necessários.", -1)
const _hoisted_24 = { class: "modules" }
const _hoisted_25 = ["checked", "onChange"]
const _hoisted_26 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_27 = { class: "spacing" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("h1", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Assuntos de documento")
], -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("h2", null, "Assuntos padrão que serão criados junto com o tenant. Desmarque os que não forem necessários ou adicione novos.", -1)
const _hoisted_30 = { class: "subjects-grid" }
const _hoisted_31 = ["checked", "onChange"]
const _hoisted_32 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_33 = { class: "add-subject" }
const _hoisted_34 = ["onKeydown"]
const _hoisted_35 = ["disabled"]
const _hoisted_36 = { class: "spacing users-section" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("h1", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Usuários"),
  /*#__PURE__*/_createTextVNode(" (obrigatório ao menos 1)")
], -1)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("h2", null, "Esses usuários serão criados junto com o tenant e poderão acessá-lo imediatamente.", -1)
const _hoisted_39 = ["onClick"]
const _hoisted_40 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  viewBox: "0 0 24 24",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M18 6L6 18",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M6 6L18 18",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1)
const _hoisted_41 = [
  _hoisted_40
]
const _hoisted_42 = { class: "double" }
const _hoisted_43 = ["onUpdate:modelValue"]
const _hoisted_44 = ["onUpdate:modelValue"]
const _hoisted_45 = { class: "double" }
const _hoisted_46 = ["onUpdate:modelValue"]
const _hoisted_47 = ["onUpdate:modelValue"]
const _hoisted_48 = ["onMousedown"]
const _hoisted_49 = ["disabled"]

import { computed, ref, watch } from 'vue'
import MySelect from '@/components/select/MySelect.vue'
import { useAxios } from '@/api/axios'
import { AxiosResponse } from 'axios'
import { TenantModel } from '@/models/TenantModel'
import { TenantSectorEnum, tenantSectorLabels } from '@/enums/Tenants/TenantSectorEnum'
import { TenantModuleEnum, tenantModuleLabels } from '@/enums/Tenants/TenantModuleEnum'
import { TENANT_ROLE_TEMPLATES, DEFAULT_DOCUMENT_SUBJECTS } from '@/global/config/tenantProvisioningDefaults'
import SpinnerLoaderButton from '@/components/loader/SpinnerLoaderButton.vue'
import { toast } from 'vue3-toastify'
import router from '@/router'

interface NewTenantUser {
  name?: string
  last_name?: string
  email?: string
  password?: string
  role?: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CreateTenantView',
  setup(__props) {

const axios = useAxios()
const isCreatingTenant = ref(false)
const logoPreview = ref<string>('')
const customSubjectInput = ref('')
const customSubjects = ref<string[]>([])

const payload = ref<{
  name?: string
  acronym?: string
  sector?: TenantSectorEnum
  logo?: File
  modules: TenantModuleEnum[]
  roles: string[]
  documentSubjects: string[]
  users: NewTenantUser[]
}>({
  modules: [],
  roles: TENANT_ROLE_TEMPLATES.filter((template) => !template.chamberOnly).map((template) => template.name),
  documentSubjects: [...DEFAULT_DOCUMENT_SUBJECTS],
  users: [{}]
})

const allSubjectOptions = computed(() => [...DEFAULT_DOCUMENT_SUBJECTS, ...customSubjects.value])

const canSubmit = computed(() => {
  if (!payload.value.name || !payload.value.sector || !payload.value.roles.length) return false
  if (!payload.value.users.length) return false
  return payload.value.users.every((newUser) => {
    return !!(newUser.name && newUser.last_name && newUser.email && newUser.password && newUser.password.length >= 6 && newUser.role && payload.value.roles.includes(newUser.role))
  })
})

watch(() => payload.value.sector, (sector) => {
  const chamberOnlyNames = TENANT_ROLE_TEMPLATES.filter((template) => template.chamberOnly).map((template) => template.name)

  if (sector === TenantSectorEnum.CHAMBER) {
    chamberOnlyNames.forEach((name) => {
      if (!payload.value.roles.includes(name)) payload.value.roles.push(name)
    })
  } else {
    payload.value.roles = payload.value.roles.filter((roleName) => !chamberOnlyNames.includes(roleName))
  }
})

function handleLogoChange (event: Event) {
  const input = event.target as HTMLInputElement
  const file: File | null = input.files && input.files[0]
  if (file) {
    payload.value.logo = file
    logoPreview.value = URL.createObjectURL(file)
  }
}

function toggleModule (module: TenantModuleEnum, checked: boolean) {
  const modules = new Set(payload.value.modules)
  checked ? modules.add(module) : modules.delete(module)
  payload.value.modules = Array.from(modules)
}

function toggleRole (roleName: string, checked: boolean) {
  const roles = new Set(payload.value.roles)
  checked ? roles.add(roleName) : roles.delete(roleName)
  payload.value.roles = Array.from(roles)
}

function toggleSubject (subject: string, checked: boolean) {
  const subjects = new Set(payload.value.documentSubjects)
  checked ? subjects.add(subject) : subjects.delete(subject)
  payload.value.documentSubjects = Array.from(subjects)
}

function addCustomSubject () {
  const value = customSubjectInput.value.trim()
  if (!value || allSubjectOptions.value.includes(value)) return

  customSubjects.value.push(value)
  payload.value.documentSubjects.push(value)
  customSubjectInput.value = ''
}

function addUserRow () {
  payload.value.users.push({})
}

function removeUserRow (index: number) {
  payload.value.users.splice(index, 1)
}

function createTenant (): void {
  isCreatingTenant.value = true

  const formData = new FormData()
  formData.append('name', payload.value.name!)
  if (payload.value.acronym) {
    formData.append('acronym', payload.value.acronym)
  }
  formData.append('sector', payload.value.sector!)
  if (payload.value.logo) {
    formData.append('logo', payload.value.logo)
  }
  payload.value.modules.forEach((module, index) => {
    formData.append(`modules[${index}]`, module)
  })
  payload.value.roles.forEach((roleName, index) => {
    formData.append(`roles[${index}]`, roleName)
  })
  payload.value.documentSubjects.forEach((subject, index) => {
    formData.append(`document_subjects[${index}]`, subject)
  })
  payload.value.users.forEach((newUser, index) => {
    formData.append(`users[${index}][name]`, newUser.name!)
    formData.append(`users[${index}][last_name]`, newUser.last_name!)
    formData.append(`users[${index}][email]`, newUser.email!)
    formData.append(`users[${index}][password]`, newUser.password!)
    formData.append(`users[${index}][role]`, newUser.role!)
  })

  axios.post('/api/platform-admin/tenants', formData)
    .then((res: AxiosResponse<TenantModel>) => {
      toast.success('Tenant criado com sucesso')
      router.push({ name: 'platform-admin.tenants.edit', params: { id: res.data.id } })
    })
    .finally(() => isCreatingTenant.value = false)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({ name: 'platform-admin.tenants.index' }))),
      class: "back"
    }, _hoisted_4),
    _createElementVNode("section", _hoisted_5, [
      _hoisted_6,
      _createElementVNode("div", {
        class: _normalizeClass(["data", { 'nophoto': !logoPreview.value }])
      }, [
        _createElementVNode("div", {
          style: _normalizeStyle({ backgroundImage: logoPreview.value ? 'url(' + logoPreview.value + ')' : '' })
        }, _hoisted_8, 4),
        _createElementVNode("input", {
          autocomplete: "off",
          type: "file",
          accept: "image/*",
          name: "tenant-logo",
          id: "tenant-logo",
          onChange: _cache[1] || (_cache[1] = ($event: any) => (handleLogoChange($event)))
        }, null, 32),
        _hoisted_9
      ], 2)
    ]),
    _createElementVNode("section", _hoisted_10, [
      _createElementVNode("section", null, [
        _hoisted_11,
        _withDirectives(_createElementVNode("input", {
          type: "text",
          placeholder: "Ex: Prefeitura de Canindé",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((payload.value.name) = $event))
        }, null, 512), [
          [_vModelText, payload.value.name]
        ])
      ]),
      _createElementVNode("section", null, [
        _hoisted_12,
        _withDirectives(_createElementVNode("input", {
          type: "text",
          placeholder: "Ex: P.M.C",
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((payload.value.acronym) = $event))
        }, null, 512), [
          [_vModelText, payload.value.acronym]
        ])
      ])
    ]),
    _createElementVNode("section", null, [
      _hoisted_13,
      _createVNode(MySelect, {
        name: 'sector',
        for: 'sector',
        currentValue: payload.value.sector ? _unref(tenantSectorLabels)[payload.value.sector] : null
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.values(_unref(TenantSectorEnum)), (sector) => {
            return (_openBlock(), _createElementBlock("li", {
              key: sector,
              onMousedown: ($event: any) => (payload.value.sector = sector)
            }, _toDisplayString(_unref(tenantSectorLabels)[sector]), 41, _hoisted_14))
          }), 128))
        ]),
        _: 1
      }, 8, ["currentValue"])
    ]),
    _createElementVNode("section", _hoisted_15, [
      _hoisted_16,
      _hoisted_17,
      _createElementVNode("div", _hoisted_18, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.values(_unref(TenantModuleEnum)), (module) => {
          return (_openBlock(), _createElementBlock("label", {
            class: "module-toggle",
            key: module
          }, [
            _createElementVNode("input", {
              type: "checkbox",
              checked: payload.value.modules.includes(module),
              onChange: ($event: any) => (toggleModule(module, ($event.target as HTMLInputElement).checked))
            }, null, 40, _hoisted_19),
            _hoisted_20,
            _createElementVNode("p", null, _toDisplayString(_unref(tenantModuleLabels)[module]), 1)
          ]))
        }), 128))
      ])
    ]),
    _createElementVNode("section", _hoisted_21, [
      _hoisted_22,
      _hoisted_23,
      _createElementVNode("div", _hoisted_24, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(TENANT_ROLE_TEMPLATES), (template) => {
          return (_openBlock(), _createElementBlock("label", {
            class: "module-toggle",
            key: template.name
          }, [
            _createElementVNode("input", {
              type: "checkbox",
              checked: payload.value.roles.includes(template.name),
              onChange: ($event: any) => (toggleRole(template.name, ($event.target as HTMLInputElement).checked))
            }, null, 40, _hoisted_25),
            _hoisted_26,
            _createElementVNode("p", null, _toDisplayString(template.name), 1)
          ]))
        }), 128))
      ])
    ]),
    _createElementVNode("section", _hoisted_27, [
      _hoisted_28,
      _hoisted_29,
      _createElementVNode("div", _hoisted_30, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(allSubjectOptions.value, (subject) => {
          return (_openBlock(), _createElementBlock("label", {
            class: "subject-chip",
            key: subject
          }, [
            _createElementVNode("input", {
              type: "checkbox",
              checked: payload.value.documentSubjects.includes(subject),
              onChange: ($event: any) => (toggleSubject(subject, ($event.target as HTMLInputElement).checked))
            }, null, 40, _hoisted_31),
            _hoisted_32,
            _createElementVNode("p", null, _toDisplayString(subject), 1)
          ]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_33, [
        _withDirectives(_createElementVNode("input", {
          type: "text",
          placeholder: "Adicionar assunto personalizado",
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((customSubjectInput).value = $event)),
          onKeydown: _withKeys(_withModifiers(addCustomSubject, ["prevent"]), ["enter"])
        }, null, 40, _hoisted_34), [
          [_vModelText, customSubjectInput.value]
        ]),
        _createElementVNode("input", {
          type: "button",
          value: "Adicionar",
          disabled: !customSubjectInput.value.trim(),
          onClick: addCustomSubject
        }, null, 8, _hoisted_35)
      ])
    ]),
    _createElementVNode("section", _hoisted_36, [
      _hoisted_37,
      _hoisted_38,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(payload.value.users, (newUser, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "user-form",
          key: index
        }, [
          (payload.value.users.length > 1)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "remove",
                onClick: ($event: any) => (removeUserRow(index))
              }, _hoisted_41, 8, _hoisted_39))
            : _createCommentVNode("", true),
          _createElementVNode("section", _hoisted_42, [
            _createElementVNode("section", null, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                placeholder: "Nome",
                "onUpdate:modelValue": ($event: any) => ((newUser.name) = $event)
              }, null, 8, _hoisted_43), [
                [_vModelText, newUser.name]
              ])
            ]),
            _createElementVNode("section", null, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                placeholder: "Sobrenome",
                "onUpdate:modelValue": ($event: any) => ((newUser.last_name) = $event)
              }, null, 8, _hoisted_44), [
                [_vModelText, newUser.last_name]
              ])
            ])
          ]),
          _createElementVNode("section", _hoisted_45, [
            _createElementVNode("section", null, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                placeholder: "E-mail",
                "onUpdate:modelValue": ($event: any) => ((newUser.email) = $event)
              }, null, 8, _hoisted_46), [
                [_vModelText, newUser.email]
              ])
            ]),
            _createElementVNode("section", null, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                placeholder: "Senha (mín. 6 caracteres)",
                "onUpdate:modelValue": ($event: any) => ((newUser.password) = $event)
              }, null, 8, _hoisted_47), [
                [_vModelText, newUser.password]
              ])
            ])
          ]),
          _createElementVNode("section", null, [
            _createVNode(MySelect, {
              name: `user-${index}-role`,
              for: `user-${index}-role`,
              currentValue: newUser.role ?? null
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(payload.value.roles, (roleName) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: roleName,
                    onMousedown: ($event: any) => (newUser.role = roleName)
                  }, _toDisplayString(roleName), 41, _hoisted_48))
                }), 128))
              ]),
              _: 2
            }, 1032, ["name", "for", "currentValue"])
          ])
        ]))
      }), 128)),
      _createElementVNode("button", {
        class: "add-user-row",
        onClick: addUserRow
      }, "+ adicionar outro usuário")
    ]),
    _createElementVNode("nav", null, [
      (!isCreatingTenant.value)
        ? (_openBlock(), _createElementBlock("input", {
            key: 0,
            type: "button",
            value: "Criar tenant",
            disabled: !canSubmit.value,
            onClick: createTenant
          }, null, 8, _hoisted_49))
        : (_openBlock(), _createBlock(SpinnerLoaderButton, {
            key: 1,
            height: 60,
            maxWidth: 464
          })),
      _createElementVNode("input", {
        type: "button",
        value: "Cancelar",
        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$router.push({ name: 'platform-admin.tenants.index' })))
      })
    ])
  ]))
}
}

})